import {
  Component,
  EventEmitter,
  OnInit,
  OnChanges,
  Output,
  Input,
  SimpleChanges
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { EventPartnerModel } from '../../../../../models/event-partner.model';
import { CommonSharedModule } from '../../../../common/shared.module';
import { FakeDataService } from '../../../fake-data.service';
import { EventDashboardService } from '../../../../services/event-dashboard.service';

@Component({
  selector: 'app-partner-details',
  templateUrl: './partner-details.component.html',
  styleUrls: ['./partner-details.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class PartnerDetailsComponent implements OnInit, OnChanges {
  @Output() refreshNotes = new EventEmitter();
  @Input() eventRegistrationId!: number;
  @Input() isMRPPProgram!: boolean;
  formPartnerDetails!: FormGroup;
  msgsEngDetails!: any[];
  partnermsgs!: any[];
  partbtnNav = false;
  eventPartner!: EventPartnerModel;
  updatePartnerDetails!: EventPartnerModel;
  isReadonlyEng = true;
  btnNavEngDetails = false;
  loading = false;
  categoryName!: string;

  constructor(
    private fakeDataService: FakeDataService,
    private formBuilder: FormBuilder,
    private eventDashboardService: EventDashboardService
  ) {}

  ngOnInit() {
    this.formPartnerDetails = this.formBuilder.group({
      partnerMpnId: [''],
      partnerName: [''],
      partnerOneId: [''],
      partnerInputRequestorContact: [''],
      partnerInputRequestorEmail: [''],
      partnerLocation: [''],
      pmoconfirmedPartnerMpnid: [''],
      pmoconfirmedPartnerName: [''],
      partnerEarnedLocation: [''],
      partnerAreaLocationA14: [''],
      additionalContactEmails: [''],
      customerCountry: ['']
    });
    this.formPartnerDetails.disable();

    this.loadEventPartner();
  }

  loadEventPartner(): void {
    this.msgsEngDetails = [];
    this.loading = true;
    this.eventDashboardService
      .getEventPartnerDetails(this.eventRegistrationId)
      .subscribe(data => {
        this.formPartnerDetails.patchValue({
          partnerMpnId: data.partnerMpnId,
          partnerName: data.partnerName,
          partnerOneId: data.partnerOneId,
          partnerInputRequestorContact: data.partnerInputRequestorContact,
          partnerInputRequestorEmail: data.partnerInputRequestorEmail,
          partnerLocation: data.partnerLocation,
          pmoconfirmedPartnerMpnid: data.pmoconfirmedPartnerMpnid,
          pmoconfirmedPartnerName: data.pmoconfirmedPartnerName,
          additionalContactEmails: data.additionalContactEmails,
          partnerEarnedLocation: data.partnerEarnedLocation,
          partnerAreaLocationA14: data.partnerAreaLocationA14,
          categoryName: data.categoryName,
          customerCountry: data.customerCountry
        });
        this.loading = false;
        this.eventPartner = data;
        this.categoryName = data.categoryName;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['eventRegistrationId'].firstChange === false) {
      this.ngOnInit();
    }
  }

  editPartnerDetails() {
    this.isReadonlyEng = false;
    this.btnNavEngDetails = true;
    this.formPartnerDetails.enable();
  }

  editPartnerDetailsCancel() {
    this.loadEventPartner();
    this.isReadonlyEng = true;
    this.btnNavEngDetails = false;
    this.formPartnerDetails.disable();
  }

  onSubmitPartnerDetails() {
    this.updatePartnerDetails = {
      eventRegistrationId: this.eventRegistrationId,
      partnerMpnId: this.formPartnerDetails.controls['partnerMpnId'].value,
      partnerName: this.formPartnerDetails.controls['partnerName'].value,
      partnerOneId: this.formPartnerDetails.controls['partnerOneId'].value,
      partnerInputRequestorContact:
        this.formPartnerDetails.controls['partnerInputRequestorContact'].value,
      partnerInputRequestorEmail:
        this.formPartnerDetails.controls['partnerInputRequestorEmail'].value,
      partnerLocation:
        this.formPartnerDetails.controls['partnerLocation'].value,
      pmoconfirmedPartnerMpnid:
        this.formPartnerDetails.controls['pmoconfirmedPartnerMpnid'].value,
      pmoconfirmedPartnerName:
        this.formPartnerDetails.controls['pmoconfirmedPartnerName'].value,
      additionalContactEmails:
        this.formPartnerDetails.controls['additionalContactEmails'].value
    } as EventPartnerModel;

    this.eventDashboardService
      .updatePartnerDetails(this.updatePartnerDetails)
      .subscribe(
        () => {
          this.btnNavEngDetails = !this.btnNavEngDetails;
          this.isReadonlyEng = !this.isReadonlyEng;
          this.refreshNotes.emit('');
          this.loadEventPartner();
          this.msgsEngDetails = [];
          this.msgsEngDetails.push({
            severity: 'success',
            detail: 'Partner Info Details Updated Successfully'
          });
        },
        () => {
          this.msgsEngDetails = [];
          this.msgsEngDetails.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while Updating Partner Info Details'
          });
        }
      );
  }

  get release(): string {
    return environment.isProdEnvironment ? 'Prod' : 'Dev';
  }
}
